import { Locale, type Localized } from "../schema/Locale.js";

export function sameValueForEveryLocale<T>(value: T): Localized<T> {
	return Object.fromEntries(Object.values(Locale).map((locale) => [locale, value])) as Record<Locale, T>;
}
